import { PhoneOff, CreditCard } from "lucide-react";

interface BlockedScreenProps {
  variant: "no-plan" | "no-credits";
  dashboardUrl: string;
}

export function BlockedScreen({ variant, dashboardUrl }: BlockedScreenProps) {
  const noPlan = variant === "no-plan";

  const billingUrl = `${dashboardUrl}/dashboard/settings?tab=billing`;

  return (
    <div className="flex h-full flex-col items-center justify-center gap-6 bg-background px-8 text-center">
      {/* Icon */}
      <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-muted">
        {noPlan ? (
          <PhoneOff className="h-7 w-7 text-muted-foreground" />
        ) : (
          <CreditCard className="h-7 w-7 text-muted-foreground" />
        )}
      </div>

      {/* Copy */}
      <div className="space-y-2">
        <p className="text-base font-semibold text-foreground">
          {noPlan ? "No active plan" : "Out of credits"}
        </p>
        <p className="text-sm leading-relaxed text-muted-foreground">
          {noPlan
            ? "Your trial has ended or your plan is inactive. Upgrade to continue making calls."
            : "Your credit balance is empty. Top up your account to continue making calls."}
        </p>
      </div>

      {/* CTA */}
      <a
        href={billingUrl}
        target="_blank"
        rel="noreferrer"
        className="inline-flex h-10 items-center justify-center rounded-lg bg-primary px-5 text-sm font-medium text-primary-foreground transition-opacity hover:opacity-90"
      >
        {noPlan ? "Upgrade plan" : "Top up credits"}
      </a>
    </div>
  );
}
